import { createSelector } from 'reselect';
import checkFeatureFlag from 'utils/featureFlags';
export const selectShouldShowCsvImports = createSelector((store) => store.utils.featureFlags, (featureFlags) => checkFeatureFlag(featureFlags, 'csv_imports'));
